import {RenderedLetterPdfData} from "../../../../generated/graphql";
import {LetterPdfData} from "./generateLetterPdf";

/**
 * Mappt die GraphQL-Antwort (RenderedLetterPdfData) auf das Client-seitige
 * LetterPdfData-Interface fuer die PDF-Generierung.
 * Ersetzt null-Werte durch undefined (GraphQL liefert null, PDF erwartet undefined).
 */
export function mapRenderedToLetterPdfData(rendered: RenderedLetterPdfData): LetterPdfData {
    return {
        subject: rendered.subject,
        headerText: rendered.headerText,
        footerText: rendered.footerText,
        signature: rendered.signature,
        recipientFirstName: rendered.recipientFirstName || undefined,
        recipientLastName: rendered.recipientLastName || undefined,
        recipientStreet: rendered.recipientStreet || undefined,
        recipientHouseNumber: rendered.recipientHouseNumber || undefined,
        recipientPostCode: rendered.recipientPostCode || undefined,
        recipientCity: rendered.recipientCity || undefined,
        recipientAddition: rendered.recipientAddition || undefined,
        senderName: rendered.senderName || undefined,
        senderStreet: rendered.senderStreet || undefined,
        senderStreetNumber: rendered.senderStreetNumber || undefined,
        senderZip: rendered.senderZip || undefined,
        senderCity: rendered.senderCity || undefined,
        senderLogoBase64: rendered.senderLogoBase64 || undefined,
        senderPhone: rendered.senderPhone || undefined,
        senderEmail: rendered.senderEmail || undefined,
        senderWebsite: rendered.senderWebsite || undefined,
        senderBankName: rendered.senderBankName || undefined,
        senderIban: rendered.senderIban || undefined,
        senderBic: rendered.senderBic || undefined,
        senderTaxId: rendered.senderTaxId || undefined,
        senderTaxNumber: rendered.senderTaxNumber || undefined,
        courseDetails: rendered.courseDetails
            ? {
                  courseName: rendered.courseDetails.courseName || undefined,
                  courseNumber: rendered.courseDetails.courseNumber || undefined,
                  locationName: rendered.courseDetails.locationName || undefined,
                  locationStreet: rendered.courseDetails.locationStreet || undefined,
                  locationCity: rendered.courseDetails.locationCity || undefined,
                  courseStartDate: rendered.courseDetails.courseStartDate || undefined,
                  courseEndDate: rendered.courseDetails.courseEndDate || undefined,
                  courseTime: rendered.courseDetails.courseTime || undefined,
                  coursePrice: rendered.courseDetails.coursePrice || undefined,
                  courseLessonsCount: rendered.courseDetails.courseLessonsCount || undefined,
                  attendeeName: rendered.courseDetails.attendeeName || undefined,
              }
            : undefined,
    };
}
